/* eslint-disable react/prop-types */
import { Autocomplete, TextField } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectProducts } from '../features/apps/common-types/slice'

function ProductAutocomplete({
  name,
  value,
  size,
  error,
  helperText,
  required,
  fullWidth,
  disabled,
  onChange,
  onBlur,
  sx = []
}) {
  const [options, setOptions] = useState([])

  const products = useSelector(selectProducts)

  const selectedOption =
    options.find((v) => {
      return v.value == value
    }) || null

  useEffect(() => {
    setOptions(
      Object.values(products)
        .filter((p) => p.is_active)
        .map((row) => {
          const label = row.name
          return {
            label,
            value: row.id
          }
        })
    )
  }, [])

  return (
    <Autocomplete
      disablePortal
      value={selectedOption}
      disabled={disabled}
      options={options}
      isOptionEqualToValue={(option, value) => {
        return option.value === value.value
      }}
      getOptionLabel={(option) => {
        return option ? option.label : ''
      }}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      onBlur={onBlur}
      onChange={(e, opt) => {
        e.target = {
          id: `${name}-autocomplete-input`,
          name,
          value: opt ? opt.value ?? '' : ''
        }
        if (onChange) {
          onChange(e)
        }
      }}
      renderInput={(params) => {
        return (
          <TextField
            id={`${name}-autocomplete-input`}
            {...params}
            required={required || false}
            fullWidth={fullWidth || false}
            name={name}
            size={size || 'small'}
            label="Products"
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>{params.InputProps.endAdornment}</Fragment>
              )
            }}
          />
        )
      }}
    />
  )
}

export default ProductAutocomplete
